import { useState } from 'react'
import { Button, Drawer, Flex, Space } from 'antd'
import { MenuOutlined } from '@ant-design/icons'

import { Login } from './actions/login'
import { Logo } from './logo'
import { Menus } from './menus/menus'
import { HeaderWrapper, MobileMenuButton, MobileDrawerContent, DesktopContent } from './styled'
import { colors } from 'src/styles/theme'
import { Links } from './links'
import { SocialMediaLinks } from 'src/components/socialMediaLinks'
import { Body } from 'src/components/typography'
import Close from 'src/assets/icons/close.svg'
import classes from './index.module.css'

export const Header = () => {
  const [drawerVisible, setDrawerVisible] = useState(false)

  const toggleDrawer = () => {
    setDrawerVisible(!drawerVisible)
  }

  const closeDrawer = () => {
    setDrawerVisible(false)
  }

  return (
    <HeaderWrapper>
      <Logo />

      {/* Desktop Menu - Hidden on mobile */}
      <DesktopContent>
        <Menus />
        <Login />
      </DesktopContent>

      {/* Mobile Menu Button - Hidden on desktop */}
      <MobileMenuButton>
        <Button type="text" icon={<MenuOutlined />} onClick={toggleDrawer} size="large" />
      </MobileMenuButton>

      {/* Mobile Drawer */}
      <Drawer
        placement="left"
        onClose={closeDrawer}
        closeIcon={<img src={Close} />}
        open={drawerVisible}
        width={'100%'}
        style={{ backgroundColor: colors.neutral200 }}
        className={classes.drawer}
      >
        <MobileDrawerContent>
          <Space size="large" direction="vertical" style={{ width: '100%', flex: 1 }}>
            <Menus isMobile onMenuClick={closeDrawer} />
            <Login
              buttonIconPosition="end"
              style={{ width: 168, display: 'flex', justifyContent: 'space-between' }}
              onLoginClick={closeDrawer}
            />
            <Links onLinkClick={closeDrawer} />
          </Space>
          <Flex vertical style={{ paddingLeft: 10, flex: 0 }} justify="center" gap={10}>
            <SocialMediaLinks labelColor="black" style={{ justifyContent: 'space-between' }} />
            <Body style={{ fontSize: 13, color: colors.grey3 }}>
              All rights reserved | {new Date().getFullYear()} © Connect Up
            </Body>
          </Flex>
        </MobileDrawerContent>
      </Drawer>
    </HeaderWrapper>
  )
}
